import { useEffect } from 'react';
import { useApiStatus } from '../contexts/ApiStatusContext';

export default function ApiStatusGate() {
  const { apiUnavailable } = useApiStatus();

  useEffect(() => {
    if (apiUnavailable && window.location.pathname !== '/service-unavailable') {
      window.location.replace('/service-unavailable');
    }
  }, [apiUnavailable]);

  return null;
}
